export default "__VITE_ASSET__0r5ZtwY4__"